import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import QuemSomos from './pages/QuemSomos';
import SejaProdutor from './pages/SejaProdutor';
import CentroLegal from './pages/CentroLegal';
import CookieConsent from './components/common/CookieConsent';
import GlobalStyle from './styles/global';
import './App.css';

function App() {
  return (
    <Router>
      <GlobalStyle />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quienes-somos" element={<QuemSomos />} />
          <Route path="/seja-produtor" element={<SejaProdutor />} />
          <Route path="/centro-legal" element={<CentroLegal />} />
          <Route path="/politicas-privacidad" element={<Navigate to="/centro-legal" replace />} />
          <Route path="/terminos-uso" element={<Navigate to="/centro-legal" replace />} />
          <Route path="/politica-cookies" element={<Navigate to="/centro-legal" replace />} />
          <Route path="/ayuda-floqss" element={<Navigate to="/centro-legal" replace />} />
        </Routes>
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
